import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';

type ChipColor = NonNullable<ChipProps['color']>;

interface StatusChipProps {
  label: React.ReactNode;
  /** Explicit colour; takes precedence over `value` + `colorMap`. */
  color?: ChipColor;
  /** Status code looked up in `colorMap`, e.g. one of the maps in consts.ts. */
  value?: string | null;
  colorMap?: Record<string, ChipColor>;
  icon?: ChipProps['icon'];
  /** Outlined for secondary facts next to the main status. */
  variant?: ChipProps['variant'];
  title?: string;
}

/** The one way detail views show a status. */
export const StatusChip = ({
  label,
  color,
  value,
  colorMap,
  icon,
  variant = 'filled',
  title,
}: StatusChipProps) => (
  <Chip
    size="small"
    label={label}
    icon={icon}
    title={title}
    variant={variant}
    color={color ?? (value ? colorMap?.[value] : undefined) ?? 'default'}
    sx={{ fontWeight: 600 }}
  />
);
